import axios from "axios";
import moment from "moment";
import valid from "card-validator";
import { PDF_LOGO_URL } from "./Constants";

export const regexEmail = /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/;
export const regexSenha = /^(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
export const REGEX_PASSWORD_SPECIAL = /[!@#$%^&*()\-_=+[\]{};:'",.<>\/?\\|`~]/;

export const createFormikValidation = (formMap, values) => {
    const errors = {};

    for (let [key, value] of formMap) {
        if (!values[key] && values[key] !== 0) {
            errors[key] = "O campo " + value + " é obrigatório.";
        } else if (key.includes("email") && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values[key])) {
            errors[key] = "Você precisa informar um e-mail válido.";
        } else if ((key.includes("senha") || key.includes("password") || key.includes("new_password")) && values[key].length < 8 /* && !regexSenha.test(values[key]) */) {
            // errors[key] = "A senha deve ter pelo menos 6 caracteres e pelo menos um símbolo especial.";
            //errors[key] = "A senha deve ter pelo menos 8 caracteres.";
        } else if (key.includes("cep") && values[key].length < 5) {
            errors[key] = "Utilize no mínimo 8 caracteres.";
        } else if (key.includes("cpf") && key.includes("cnpj")) {
            if (values[key].length > 14 && !validaCnpj(values[key])) {
                errors[key] = "O CNPJ informado é inválido.";
            } else if (values[key].length <= 14 && !validaCpf(values[key])) {
                errors[key] = "O CPF informado é inválido.";
            }
        } else if ((key.includes("cpf") || key.includes("documento_titular")) && !key.includes("cnpj") && !validaCpf(values[key])) {
            errors[key] = "O CPF informado é inválido.";
        } else if (key.includes("cnpj") && !key.includes("cpf") && !validaCnpj(values[key])) {
            errors[key] = "O CNPJ informado é inválido.";
        } else if (key.includes("telefone") && values[key].length < 14) {
            errors[key] = "Utilize no mínimo 10 números.";
        } else if (key.includes("numero_cartao") && !cardValidator(values[key])) {
            errors[key] = "O número do cartão é inválido.";
        }
    }

    return errors;
};

export const validateCustomerCorporate = (values) => {
    const map = new Map();
    const errors = {};

    map.set("segment", "");
    map.set("ctm_name", "");
    map.set("ctm_email", "");
    map.set("ctm_cnpj", "");
    map.set("ctm_phone", "");
    map.set("ctm_responsible_name", "");
    map.set("ctm_postal_code", "");
    map.set("ctm_address", "");
    map.set("ctm_number", "");
    map.set("ctm_neighborhood", "");
    map.set("ctm_city", "");
    map.set("ctm_state", "");

    const baseErrors = createFormikValidation(map, values);

    const anyPassword = values.senha_atual || values.senha_nova || values.senha_confirmacao;
    if (anyPassword) {
        if (!values.senha_atual) errors.senha_atual = "Informe a senha atual";
        if (!values.senha_nova) errors.senha_nova = "Informe a nova senha";
        if (!values.senha_confirmacao) errors.senha_confirmacao = "Confirme a nova senha";

        if (values.senha_nova && values.senha_confirmacao && values.senha_nova !== values.senha_confirmacao) {
            errors.senha_confirmacao = "As senhas não coincidem";
        }
    }

    return { ...baseErrors, ...errors };
};

export const shallowEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
};

export const formatBRL = (value) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    value = "R$ " + formatter.format(value);

    return value;
};

export const formatBRLAbreviado = (value) => {
    value = "R$ " + formatLargeNumberToString(value);

    return value;
};

export const formatBRLInput = (input) => {
    input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, "")) / 10 ** 2;

    input.target.value = formatBRL(input.target.value);

    return input;
};

export const limparMoeda = (valor, parse) => {
    valor = valor.replace("R$", "");
    valor = valor.replace(".", "");
    valor = valor.replace(",", ".");
    valor = valor.replace("/^p{Z}+|p{Z}+$/u", "");
    valor = valor.trim();

    if (valor == "") return 0;

    return parse ? parseFloat(valor) : valor;
};

export const buscaCep = (input, setFieldValue, nomeEndereco, nomeBairro, nomeCidade, nomeUf, onLoading) => {
    if (input.target.value.length > 8) {
        var cep = input.target.value.replace(/[^0-9]/, "");

        const instance = axios.create();

        if (onLoading) {
            onLoading(true);
        }

        instance
            .get(`https://viacep.com.br/ws/${cep}/json/`, {})
            .then((res) => {
                if (res.data.erro) {
                    setFieldValue(nomeEndereco, "");
                    setFieldValue(nomeBairro, "");
                    setFieldValue(nomeCidade, "");
                    setFieldValue(nomeUf, "");
                } else {
                    setFieldValue(nomeEndereco, res.data.logradouro ?? "");
                    setFieldValue(nomeBairro, res.data.bairro ?? "");
                    setFieldValue(nomeCidade, res.data.localidade ?? "");
                    setFieldValue(nomeUf, res.data.uf ?? "");
                }
            })
            .catch((err) => {})
            .finally(() => {
                if (onLoading) {
                    onLoading(false);
                }
            });
    }

    return formatCepInput(input);
};

export const formatCepInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{5})(\d)/, "$1-$2");

    input.target.value = value;

    return input;
};

export const listaUfs = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"];

export const formatDataInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");

    input.target.value = value;

    return input;
};

export const formatDataCartaoInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");

    input.target.value = value;

    return input;
};

export const formatCVV = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");

    input.target.value = value;

    return input;
};

export const formatNumeroCartao = (input) => {
    let value = input.target.value.replace(/\D/g, "");
    const isAmex = /^(34|37)/.test(value);

    if (isAmex) {
        value = value.replace(/(\d{4})(\d{6})(\d{5})$/, "$1 $2 $3");
    } else {
        value = value.replace(/(\d{4})(?=\d)/g, "$1 ");
    }

    input.target.value = value.trim();

    return input;
};

export const enableLoading = (setLoading, setLoadingButtonStyle) => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
};

export const disableLoading = (setLoading, setLoadingButtonStyle) => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
};

export const formatData = (value) => {
    const data = value.split(" ")[0];

    return `${data.split("-")[2]}/${data.split("-")[1]}/${data.split("-")[0]}`;
};

export const formatCPFInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatTelefoneInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{0})(\d)/, "$1($2");
    value = value.replace(/(\d{2})(\d)/, "$1) $2");
    value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const lista_formato_imagens = ["jpg", "png", "jpeg", "image/jpg", "image/png", "image/jpeg"];
export const lista_formato_videos = ["mp4", "avi", "video/mp4", "video/avi"];

export const returnType = (name) => {
    const name_array = name.split(".");
    const type = name_array[name_array.length - 1];

    return type;
};

export const getCardFlag = (value) => {
    let card = value?.replace(/[^0-9]+/g, "");

    let cards = {
        visa: /^4[0-9]{12}(?:[0-9]{3})/,
        mastercard: /^5[1-5][0-9]{14}/,
        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
        amex: /^3[47][0-9]{13}/,
        discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
        hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
        elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
        jcb: /^(?:2131|1800|35\d{3})\d{11}/,
        aura: /^(5078\d{2})(\d{2})(\d{11})$/,
    };

    for (let flag in cards) {
        if (cards[flag].test(card)) {
            return flag;
        }
    }

    return false;
};

/* eslint-disable */
export const validaCpf = (cpf) => {
    var add = 0;
    var rev = 0;

    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf == "") return false;

    if (cpf.length != 11) return false;

    // Verifica se todos os dígitos são iguais (ex: 111.111.111-11)
    if (/^(\d)\1+$/.test(cpf)) {
        return false;
    }

    for (var i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i);
    }

    rev = 11 - (add % 11);

    if (rev == 10 || rev == 11) {
        rev = 0;
    }
    if (rev != parseInt(cpf.charAt(9))) {
        return false;
    }

    add = 0;

    for (var j = 0; j < 10; j++) {
        add += parseInt(cpf.charAt(j)) * (11 - j);
    }

    rev = 11 - (add % 11);

    if (rev == 10 || rev == 11) {
        rev = 0;
    }

    if (rev != parseInt(cpf.charAt(10))) {
        return false;
    }

    return true;
};
/* eslint-enable */

export const validaCnpj = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (cnpj.length !== 14) {
        return false;
    }

    if (/^(\d)\1+$/.test(cnpj)) {
        return false;
    }

    let add = 0;
    let rev = 0;
    let pos = 5;

    for (let i = 0; i < 12; i++) {
        add += parseInt(cnpj.charAt(i)) * pos;
        pos = pos === 2 ? 9 : pos - 1;
    }

    rev = add % 11 < 2 ? 0 : 11 - (add % 11);

    if (rev !== parseInt(cnpj.charAt(12))) {
        return false;
    }

    add = 0;
    pos = 6;

    for (let i = 0; i < 13; i++) {
        add += parseInt(cnpj.charAt(i)) * pos;
        pos = pos === 2 ? 9 : pos - 1;
    }

    rev = add % 11 < 2 ? 0 : 11 - (add % 11);

    return rev === parseInt(cnpj.charAt(13));
};

export const getIniciais = (nome) => {
    if (!nome) {
        return "";
    }

    const array_name = nome?.split(" ");
    const name = array_name[0][0];

    return name?.toUpperCase();
};

export const getPrimeiroNome = (nome) => {
    if (!nome) {
        return "";
    }

    const array_name = nome?.split(" ");

    return array_name?.length > 1 ? array_name[0] : nome;
};

export const getEnderecoInstalacao = (instalacao, resumido = false) => {
    if (!instalacao) {
        return "";
    }

    const { ins_logradouro, ins_numero, ins_complemento, ins_bairro, ins_cidade, ins_estado } = instalacao;

    if (resumido) {
        return `${ins_logradouro}, ${ins_numero}`;
    }

    const complemento = ins_complemento ? ` - ${ins_complemento}` : "";

    return `${ins_logradouro}, ${ins_numero}, ${ins_bairro}, ${ins_cidade}, ${ins_estado}${complemento}`;
};

export const listaDiaSemana = [
    { label: "Segunda-feira", value: "segunda-feira" },
    { label: "Terça-feira", value: "terca-feira" },
    { label: "Quarta-feira", value: "quarta-feira" },
    { label: "Quinta-feira", value: "quinta-feira" },
    { label: "Sexta-feira", value: "sexta-feira" },
    { label: "Sabado", value: "sabado" },
    { label: "Domingo", value: "domingo" },
];

export const formatHora = (hora) => {
    hora = hora.replace(/\D/g, "");
    hora = hora.replace(/(\d{2})(\d)/, "$1:$2");

    return hora;
};

export const getValue = (obj, path) => {
    return path.split(".").reduce((o, p) => (o ? o[p] : undefined), obj);
};

export const textoCorpoModal = (texto, dado) => {
    return texto.replace(/\{\{(.*?)\}\}/g, (_, p1) => {
        return getValue(dado, p1);
    });
};

export const formatacaoData = (data) => {
    if (moment(data).isSame(moment(), "day")) {
        return `Hoje, ${moment(data).format("HH:mm")}`;
    } else {
        return moment(data).format("DD/MM/YYYY[,] HH:mm");
    }
};

export const formatNumberToPtBr = (number) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        maximumFractionDigits: 2,
    });

    return formatter.format(number);
};

// Formata médias e scores sempre com casas decimais fixas (ex.: 4 -> "4,00").
export const formatDecimalToPtBr = (number, decimals = 2) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });

    return formatter.format(Number(number));
};

// Função para abreviar números grandes
export const formatLargeNumberToString = (num) => {
    // Função para formatar número com ponto para vírgula
    const format = ({ value, minimumFractionDigits, maximumFractionDigits }) => {
        const formatter = new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            minimumFractionDigits,
            maximumFractionDigits,
        });

        return formatter.format(value);
    };

    if (num >= 1e9) {
        return format({ value: num / 1e9, maximumFractionDigits: 1 }) + "b"; // Bilhão
    } else if (num >= 1e6) {
        return format({ value: num / 1e6, maximumFractionDigits: 1 }) + "m"; // Milhão
    } else if (num >= 1e3) {
        return format({ value: num / 1e3, maximumFractionDigits: 1 }) + "k"; // Milha
    } else {
        return num.toString(); // Menos que uma milha
    }
};

// Função para obter o nome do mês abreviado em português brasil e o ano abreviado
export const formatDateToPTBR = (date, withDay = false) => {
    // Formatter para o dia
    const dayFormatter = new Intl.DateTimeFormat("pt-BR", { day: "2-digit" });
    const day = dayFormatter.format(date).replace(".", "");

    // Opções para formatar o mês como abreviado
    const monthFormatter = new Intl.DateTimeFormat("pt-BR", { month: "short" });
    const month = monthFormatter.format(date).replace(".", "");

    // Opções para formatar o ano como dois dígitos
    const yearFormatter = new Intl.DateTimeFormat("pt-BR", { year: "2-digit" });
    const year = yearFormatter.format(date);

    // Retorna o formato desejado
    if (withDay) {
        return `${month.charAt(0).toUpperCase() + month.slice(1)} ${day}, '${year}`;
    }

    return `${month.charAt(0).toUpperCase() + month.slice(1)} '${year}`;
};

// Função para obter o dia, nome do dia da semana e mês abreviado em português brasil
export const formatWeekDayMonthToPTBR = (date) => {
    const options = {
        weekday: "short", // Abbreviated day name (e.g., "sáb.")
        day: "numeric", // Day of the month (e.g., "1")
        month: "short", // Abbreviated month name (e.g., "de out.")
    };
    const formatter = new Intl.DateTimeFormat("pt-BR", options);

    const formattedDate = formatter.format(date);

    return formattedDate.replace(/([A-Za-zá]+)\., (\d+) de (\w+)\./, (match, p1, p2, p3) => {
        let dayName = p1.charAt(0).toUpperCase() + p1.slice(1).toLowerCase();
        let monthName = p3.charAt(0).toLowerCase() + p3.slice(1).toLowerCase();
        return `${dayName}, ${p2} ${monthName}`;
    });
};

// Função para obter data e hora em português brasil
export const formatDatetimePTBR = (date) => {
    const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    };

    const formatter = new Intl.DateTimeFormat("pt-BR", options);

    return formatter.format(date).replace(",", "");
};

export const formatCNPJInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1/$2");
    value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatCPFCNPJInput = (input) => {
    let value = input.target.value;

    if (value.length > 14) {
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{2})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d)/, "$1/$2");
        value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");
    } else {
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    }

    input.target.value = value;

    return input;
};

/**
 * Rounds value up to two decimal places
 * @param {number} value eg: 10.234
 *
 * @return {number} eg: 10.24
 */
export const ceilCurrency = (value) => {
    return Math.ceil(value * 100) / 100;
};

export const validateFullName = (name) => {
    // Trim any leading/trailing spaces
    const trimmedName = name.trim();

    // Split the name by spaces (whitespace)
    const nameParts = trimmedName.split(/\s+/); // This splits by one or more spaces

    // Check if there are more than two parts and first & second are non-empty
    if (nameParts.length >= 2 && nameParts[0].length > 0 && nameParts[1].length > 0) {
        return true; // Valid first and last name
    }

    return false; // Invalid input
};

export const formatOnlyNumbersInput = (input) => {
    let value = input.target.value;

    // Remove tudo o que não for dígito (caracteres não numéricos)
    input.target.value = value.replace(/\D/g, "");

    return input;
};

export const formatNumberToPtBrDoubleInput = (input) => {
    let value = input.target.value;

    // Remove everything that is not a digit (non-numeric characters)
    value = value.replace(/\D/g, "");

    if (value === "") {
        value = "0";
    }

    // Convert to a double number with two decimal places
    const numericValue = parseFloat(value) / 100;

    // Format the number using pt-BR locale with comma as decimal separator
    input.target.value = numericValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return input;
};

export const primeiraLetraMaiuscula = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const listaStatusPagamento = [
    { key: "PENDENTE", value: "Pendente", cor: "#FFE3C3", texto: "Fatura aberta" },
    { key: "PAGO", value: "Pago", cor: "#C6FBD4", texto: "Fatura paga" },
    { key: "ATRASADO", value: "Atrasado", cor: "#FFD8D6", texto: "Fatura atrasada" },
    { key: "FALHA", value: "Falha de pagamento", cor: "#FFD8D6", texto: "Falha de pagamento" },
];

export const listaMetodoPagamento = [
    { key: "BOLETO", value: "Boleto" },
    { key: "CARTAO_CREDITO", value: "Cartão de crédito" },
];

export const listaContratoStatus = [
    { key: "AGUARDANDO_ASSINATURA", value: "Aguardando assinatura", cor: "#FFE3C3", texto: "Contrato aguardando assinatura" },
    { key: "AGUARDANDO_APROVACAO", value: "Aguardando aprovação", cor: "#FFE3C3", texto: "Contrato aguardando aprovação" },
    { key: "APROVADO", value: "Aprovado", cor: "#C6FBD4", texto: "Contrato ativo" },
    { key: "INJETANDO", value: "Injetando", cor: "#FFE3C3", texto: "Injetando" },
    { key: "CANCELADO", value: "Cancelado", cor: "#FFD8D6", texto: "Contrato cancelado" },
];

export const listaCartaoStatus = [
    { key: 1, value: "Ativo", cor: "#C6FBD4" },
    { key: 0, value: "Inativo", cor: "#FFD8D6" },
];

export const listaEstados = [
    { key: "AC", label: "Acre" },
    { key: "AL", label: "Alagoas" },
    { key: "AP", label: "Amapá" },
    { key: "AM", label: "Amazonas" },
    { key: "BA", label: "Bahia" },
    { key: "CE", label: "Ceará" },
    { key: "DF", label: "Distrito Federal" },
    { key: "ES", label: "Espírito Santo" },
    { key: "GO", label: "Goiás" },
    { key: "MA", label: "Maranhão" },
    { key: "MT", label: "Mato Grosso" },
    { key: "MS", label: "Mato Grosso do Sul" },
    { key: "MG", label: "Minas Gerais" },
    { key: "PA", label: "Pará" },
    { key: "PB", label: "Paraíba" },
    { key: "PR", label: "Paraná" },
    { key: "PE", label: "Pernambuco" },
    { key: "PI", label: "Piauí" },
    { key: "RJ", label: "Rio de Janeiro" },
    { key: "RN", label: "Rio Grande do Norte" },
    { key: "RS", label: "Rio Grande do Sul" },
    { key: "RO", label: "Rondônia" },
    { key: "RR", label: "Roraima" },
    { key: "SC", label: "Santa Catarina" },
    { key: "SP", label: "São Paulo" },
    { key: "SE", label: "Sergipe" },
    { key: "TO", label: "Tocantins" },
];

export const listaEstadoCivil = [
    { key: "SOLTEIRO", value: "Solteiro(a)" },
    { key: "CASADO_COMUNHAO_PARCIAL", value: "Casado(a) - Comunhão Parcial de Bens" },
    { key: "CASADO_COMUNHAO_UNIVERSAL", value: "Casado(a) - Comunhão Universal de Bens" },
    { key: "CASADO_SEPARACAO_TOTAL", value: "Casado(a) - Separação Total de Bens" },
    { key: "DIVORCIADO", value: "Divorciado(a)" },
    { key: "VIUVO", value: "Viúvo(a)" },
    { key: "UNIAO_ESTAVEL", value: "União Estável" },
    { key: "SEPARADO", value: "Separado(a)" },
];

export const formatDecimal = (value) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
    });

    value = formatter.format(value);

    return value;
};

export const cardValidator = (cardNumber) => {
    const validacao = valid.number(cardNumber);

    return validacao.isValid;
};

export const calcularPorcentagem = (parcial, total) => {
    if (total === 0) return "0%"; // Evita divisão por zero

    let percentual = (parcial / total) * 100;

    // Se for exatamente 100%, exibe como 100%. Caso contrário, mantém no máximo 99.9%.
    if (percentual >= 100) {
        return "100%";
    } else if (Number.isInteger(percentual)) {
        return `${percentual.toFixed(0)}%`;
    } else {
        return `${Math.min(percentual, 99.90000000000000000000001).toFixed(1)}%`;
    }
};

export const padArray3 = (arr) => {
    const remainder = arr.length % 3;
    if (remainder !== 0) {
        const toAdd = 3 - remainder;
        arr.push(...Array(toAdd).fill(null));
    }
    return arr;
};

export const isset = (value) => {
    return value !== null && value !== undefined;
};

export const formatBytesLabel = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export function validatePasswordStrength(password = "") {
    return {
        len8: password.length >= 8,
        lower: /[a-z]/.test(password),
        upper: /[A-Z]/.test(password),
        number: /\d/.test(password),
        special: REGEX_PASSWORD_SPECIAL.test(password),
    };
}

export function getRiskLevel(value) {
    if (value == null || isNaN(value)) return "Sem dados";
    if (value > 0) return "Risco baixo";
    if (value >= -0.5) return "Risco moderado";
    return "Risco alto";
}

export function formatInvoiceStatus(status) {
    switch (status) {
        case "PAID":
            return "Pago";
        default:
            return "Agendada";
    }
}

export function normalizeLabelEmotion(text) {
    if (!text || typeof text !== "string") {
        return "";
    }

    if (text !== text.toUpperCase()) {
        return text;
    }

    return text
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}

export const toCapitalize = (text = "") => {
    return text
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

export const getCardBrand = (number = "") => {
    const card = number.replace(/\D/g, "");

    if (!card) return "Desconhecido";

    // American Express
    if (/^3[47]/.test(card)) {
        return "American Express";
    }

    // Hipercard
    if (/^(606282|3841)/.test(card)) {
        return "Hipercard";
    }

    // Elo
    if (/^(4011(78|79)|431274|438935|451416|457393|457631|504175|506(699|7\d{2})|509\d{3}|627780|636(297|368))/.test(card)) {
        return "Elo";
    }

    // Discover
    if (/^(6011|65|64[4-9]|622(12[6-9]|1[3-9]\d|[2-8]\d{2}|9([01]\d|2[0-5])))/.test(card)) {
        return "Discover";
    }

    // Mastercard
    if (/^(5[1-5]|222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)/.test(card)) {
        return "Mastercard";
    }

    // Visa
    if (/^4/.test(card)) {
        return "Visa";
    }

    return "Desconhecido";
};

// EXPORTAÇÃO DE PDF

const PDF_PAGE_SIZES = {
    portrait: { width: 210, height: 297 },
    landscape: { width: 297, height: 210 },
};

// Caixa reservada à logo no cabeçalho, em mm. A imagem é encaixada dentro dela sem distorcer.
const PDF_LOGO_BOX = { top: 4, width: 30, height: 17 };

// Elementos que uma quebra de página não deve atravessar: linhas e cabeçalhos de tabela,
// imagens, gráficos e qualquer bloco marcado com data-pdf-nobreak na tela.
const PDF_NO_SPLIT_SELECTOR = "[data-pdf-nobreak], tr, thead, img, canvas, svg";

// Conteúdo de uma linha expandida (data-pdf-nobreak="linha"): além de não ser cortado, ele
// não se separa da linha da tabela que o abriu — sozinha, ela não diz nada.
const PDF_ROW_EXPANSION_SELECTOR = '[data-pdf-nobreak="linha"]';

// Títulos e cabeçalhos de tabela: não podem terminar a página com o conteúdo deles na página
// seguinte. Blocos marcados com data-pdf-nobreak="proximo" entram na mesma regra.
const PDF_KEEP_WITH_NEXT_SELECTOR = '[data-pdf-nobreak="proximo"], thead, h1, h2, h3, h4';

// Blocos que perdem o sentido partidos — uma tabela cortada no meio das linhas, um card sem o
// rodapé. Diferente dos demais, o limite aqui é a página inteira: se não couberem no que resta
// da página, começam na seguinte; só são partidos quando nem sozinhos cabem em uma página.
const PDF_KEEP_TOGETHER_SELECTOR = 'table, [data-pdf-nobreak="bloco"]';

// Só blocos até esta fração da área útil são mantidos inteiros. Um card grande (um subdomínio
// com todos os riscos, por exemplo) é dividido nos blocos internos dele — mantê-lo inteiro
// empurraria conteúdo demais para a página seguinte.
const PDF_MAX_NO_SPLIT_FILL = 0.5;

// Subir um título para não deixá-lo órfão no pé da página só vale enquanto a página ainda
// aproveitar esta fatia da área útil. Não vale para cards e tabelas: eles nunca são partidos,
// mesmo que a página sobrando fique vazia.
const PDF_MIN_PAGE_FILL = 0.4;

const PDF_SUBTITLE_FONT_SIZE = 8.5;
const PDF_SUBTITLE_TOP = 16;
const PDF_SUBTITLE_LINE_HEIGHT = 4;
const PDF_SUBTITLE_LOGO_GAP = 8;

// Proporção (largura/altura) da logo. Ler as dimensões do arquivo faz uma requisição
// síncrona e o valor não muda, então é resolvido uma única vez.
let pdfLogoAspect = null;

const resolvePdfLogoAspect = (pdf) => {
    if (pdfLogoAspect === null) {
        const { width, height } = pdf.getImageProperties(PDF_LOGO_URL);

        pdfLogoAspect = width / height;
    }

    return pdfLogoAspect;
};

const resolvePdfSubtitleLines = (pdf, subtitle, maxWidth) => {
    const text = String(subtitle ?? "").trim();

    if (!text) return [];

    pdf.setFontSize(PDF_SUBTITLE_FONT_SIZE);
    pdf.setFont(undefined, "normal");

    return pdf.splitTextToSize(text, maxWidth);
};

// Cabeçalho padrão dos relatórios: logo à esquerda, título e subtítulo à direita.
// As coordenadas são absolutas em mm, medidas a partir do topo da página.
const addPdfHeader = (pdf, pageWidth, margin, title, subtitleLines) => {
    try {
        const aspect = resolvePdfLogoAspect(pdf);
        const logoHeight = Math.min(PDF_LOGO_BOX.height, PDF_LOGO_BOX.width / aspect);
        const logoWidth = logoHeight * aspect;

        pdf.addImage(PDF_LOGO_URL, "PNG", margin, PDF_LOGO_BOX.top + (PDF_LOGO_BOX.height - logoHeight) / 2, logoWidth, logoHeight);
    } catch {
        pdf.setFillColor(100, 100, 100);
        pdf.rect(margin, 5, 30, 17, "F");
        pdf.setTextColor(255, 255, 255);
        pdf.text("LOGO", margin + 6, 14);
    }

    const rightBlockX = pageWidth - margin;

    if (title) {
        pdf.setTextColor(0, 0, 0);
        pdf.setFontSize(12);
        pdf.setFont(undefined, "bold");
        pdf.text(title, rightBlockX, 11, { align: "right" });
    }

    if (subtitleLines.length > 0) {
        pdf.setTextColor(80, 80, 80);
        pdf.setFontSize(PDF_SUBTITLE_FONT_SIZE);
        pdf.setFont(undefined, "normal");

        subtitleLines.forEach((line, index) => {
            pdf.text(line, rightBlockX, PDF_SUBTITLE_TOP + index * PDF_SUBTITLE_LINE_HEIGHT, { align: "right" });
        });
    }
};

const measurePdfBlocks = (element) => {
    const { top: elementTop, height } = element.getBoundingClientRect();

    const toBlock = (node, endNode = node) => ({
        top: node.getBoundingClientRect().top - elementTop,
        bottom: endNode.getBoundingClientRect().bottom - elementTop,
    });

    const leaves = Array.from(element.querySelectorAll("*"))
        .filter((node) => node.children.length === 0)
        .map((node) => toBlock(node));

    const blocks = Array.from(element.querySelectorAll(PDF_NO_SPLIT_SELECTOR)).map((node) => toBlock(node));

    const expansions = Array.from(element.querySelectorAll(PDF_ROW_EXPANSION_SELECTOR)).map((node) => {
        const row = node.closest("tr");

        return toBlock(row?.previousElementSibling ?? node, node);
    });

    const keepWithNext = Array.from(element.querySelectorAll(PDF_KEEP_WITH_NEXT_SELECTOR)).map((node) => toBlock(node));

    const keepTogether = Array.from(element.querySelectorAll(PDF_KEEP_TOGETHER_SELECTOR)).map((node) => toBlock(node));

    return { height, unbreakable: [...blocks, ...expansions, ...leaves], keepWithNext, leaves, keepTogether };
};

// Controles de tela (botões, ações de tabela, paginação) não têm função no PDF.
// data-pdf-hide="espaco" esconde o elemento mas mantém o espaço dele, para não desmontar grids.
const PDF_HIDDEN_SELECTOR = 'button, .btn, .btn-table-action, .table-actions-container, .p-paginator-first, .p-paginator-prev, .p-paginator-pages, .p-paginator-next, .p-paginator-last, .p-paginator .p-dropdown, [data-pdf-hide]:not([data-pdf-hide="espaco"])';

const PDF_ACTIONS_HEADER = "Ações";

const isScrollOverflow = (value) => value === "auto" || value === "scroll";

// Utilitários como .d-flex usam !important; sem ele o estilo do clone não vence a classe.
const forcePdfStyle = (node, property, value) => node.style.setProperty(property, value, "important");

const hidePdfActionColumns = (element) => {
    element.querySelectorAll(".p-datatable").forEach((table) => {
        const rows = Array.from(table.querySelectorAll("tr"));

        const actionIndexes = new Set();

        rows.forEach((row) => {
            Array.from(row.cells).forEach((cell) => {
                if ((cell.tagName === "TH" && cell.textContent.trim() === PDF_ACTIONS_HEADER) || cell.querySelector(".table-actions-container")) actionIndexes.add(cell.cellIndex);
            });
        });

        if (actionIndexes.size === 0) return;

        rows.forEach((row) => {
            Array.from(row.cells).forEach((cell) => {
                if (actionIndexes.has(cell.cellIndex) && cell.colSpan === 1) forcePdfStyle(cell, "display", "none");
            });
        });

        table.querySelectorAll("colgroup").forEach((colgroup) => {
            Array.from(colgroup.children).forEach((col, index) => {
                if (actionIndexes.has(index)) forcePdfStyle(col, "display", "none");
            });
        });
    });
};

// Ajusta o clone antes da captura: tira os controles de tela e abre áreas com rolagem,
// que de outro modo sairiam cortadas. A largura fica travada na da tela para os gráficos,
// cujo SVG tem largura fixa em px, não ficarem desalinhados do restante do layout.
const preparePdfClone = (clonedElement, width) => {
    clonedElement.querySelectorAll(PDF_HIDDEN_SELECTOR).forEach((node) => {
        forcePdfStyle(node, "display", "none");
    });

    clonedElement.querySelectorAll('[data-pdf-hide="espaco"]').forEach((node) => {
        forcePdfStyle(node, "visibility", "hidden");
    });

    hidePdfActionColumns(clonedElement);

    const view = clonedElement.ownerDocument.defaultView;

    [clonedElement, ...clonedElement.querySelectorAll("*")].forEach((node) => {
        const { overflowX, overflowY } = view.getComputedStyle(node);

        if (isScrollOverflow(overflowX) && node.scrollWidth > node.clientWidth + 1) forcePdfStyle(node, "overflow-x", "visible");

        if (isScrollOverflow(overflowY) && node.scrollHeight > node.clientHeight + 1) {
            forcePdfStyle(node, "overflow-y", "visible");
            forcePdfStyle(node, "max-height", "none");
        }
    });

    const finalWidth = Math.max(width, clonedElement.scrollWidth);

    forcePdfStyle(clonedElement, "width", `${finalWidth}px`);
    forcePdfStyle(clonedElement, "min-width", `${finalWidth}px`);
    forcePdfStyle(clonedElement, "max-width", "none");
};

const toCanvasBlocks = (blocks, ratio, maxHeight) => blocks.map(({ top, bottom }) => ({ top: top * ratio, bottom: bottom * ratio })).filter((block) => block.bottom > block.top && block.bottom - block.top <= maxHeight);

const liftPdfPageBreak = (start, limit, blocks) => {
    let breakAt = limit;

    for (let round = 0; round < 10; round += 1) {
        let lifted = breakAt;

        blocks.forEach((block) => {
            if (block.top > start && block.top < lifted && block.bottom > breakAt) lifted = block.top;
        });

        if (lifted === breakAt) break;

        breakAt = lifted;
    }

    return breakAt;
};

const liftPdfWidowHeaders = (start, end, headers, leaves) => {
    let breakAt = end;

    for (let round = 0; round < 10; round += 1) {
        const widow = headers.find((header) => header.top > start && header.bottom <= breakAt && !leaves.some((leaf) => leaf.top >= header.bottom && leaf.bottom <= breakAt));

        if (!widow) break;

        breakAt = widow.top;
    }

    return breakAt;
};

/**
 * @param {string}   elementId     id do elemento capturado.
 * @param {string}   title         título exibido no cabeçalho.
 * @param {string}   [subtitle]    subtítulo exibido abaixo do título.
 * @param {string}   [fileName]    nome do arquivo salvo. Padrão: `${elementId}.pdf`.
 * @param {string}   [orientation] "portrait" (padrão) ou "landscape".
 * @param {function} [setExporting] setter de estado, chamado com true/false.
 * @param {function} [beforeCapture] ajusta o DOM antes da captura (ex.: expandir linhas).
 * @param {function} [afterCapture]  desfaz o ajuste, sempre executado.
 */
export const exportToPDF = async ({ elementId, title, subtitle = "", fileName, orientation = "portrait", margin = 15, headerHeight = 25, scale = 2, backgroundColor = "#FFFFFF", captureDelay = 300, setExporting, beforeCapture, afterCapture, onSuccess, onError }) => {
    setExporting?.(true);
    beforeCapture?.();

    try {
        // Dá um ciclo de render para o estado de "exportando" e para os ajustes
        // de beforeCapture aparecerem na tela antes da captura.
        if (captureDelay) await new Promise((resolve) => setTimeout(resolve, captureDelay));

        const element = document.getElementById(elementId);

        if (!element) throw new Error(`Elemento "${elementId}" não encontrado para exportação.`);

        const [{ jsPDF }, { default: html2canvas }] = await Promise.all([import("jspdf"), import("html2canvas")]);

        let measured = null;

        const elementWidth = element.getBoundingClientRect().width;

        const canvas = await html2canvas(element, {
            scale,
            useCORS: true,
            logging: false,
            backgroundColor,
            // A janela do clone precisa ter a largura da tela: mais estreita, os breakpoints
            // reorganizam o layout e os gráficos ficam com a largura antiga.
            windowWidth: Math.max(window.innerWidth, element.scrollWidth),
            // Garante a captura do conteúdo que está fora da área visível.
            windowHeight: element.scrollHeight,
            onclone: (_, clonedElement) => {
                preparePdfClone(clonedElement, elementWidth);
                measured = measurePdfBlocks(clonedElement);
            },
        });

        const { width: pageWidth, height: pageHeight } = PDF_PAGE_SIZES[orientation] ?? PDF_PAGE_SIZES.portrait;

        const pdf = new jsPDF({ orientation, unit: "mm", format: "a4" });

        const imgWidth = pageWidth - margin * 2;

        const subtitleLines = resolvePdfSubtitleLines(pdf, subtitle, imgWidth - PDF_LOGO_BOX.width - PDF_SUBTITLE_LOGO_GAP);

        const resolvedHeaderHeight = Math.max(headerHeight, PDF_SUBTITLE_TOP + subtitleLines.length * PDF_SUBTITLE_LINE_HEIGHT - margin);

        // Altura útil por página, já descontadas as margens e o cabeçalho.
        const printableHeight = pageHeight - margin * 2 - resolvedHeaderHeight;

        const pxPerMm = canvas.width / imgWidth;
        const pageHeightInPx = printableHeight * pxPerMm;

        const metrics = measured ?? measurePdfBlocks(element);

        const ratio = canvas.height / metrics.height;
        const maxNoSplitHeight = pageHeightInPx * PDF_MAX_NO_SPLIT_FILL;

        const unbreakable = toCanvasBlocks(metrics.unbreakable, ratio, maxNoSplitHeight);
        const leaves = toCanvasBlocks(metrics.leaves, ratio, maxNoSplitHeight);
        const keepWithNext = toCanvasBlocks(metrics.keepWithNext, ratio, Number.POSITIVE_INFINITY);
        const keepTogether = toCanvasBlocks(metrics.keepTogether, ratio, pageHeightInPx);

        const sliceCanvas = document.createElement("canvas");
        const sliceContext = sliceCanvas.getContext("2d");

        sliceCanvas.width = canvas.width;

        let start = 0;
        let pages = 0;

        while (start < canvas.height) {
            const limit = Math.min(start + pageHeightInPx, canvas.height);

            let end = limit;

            if (limit < canvas.height) {
                const ceiling = liftPdfPageBreak(start, limit, keepTogether);

                const safeBreak = liftPdfPageBreak(start, ceiling, unbreakable);

                const withHeaders = liftPdfWidowHeaders(start, safeBreak, keepWithNext, leaves);

                end = withHeaders - start >= pageHeightInPx * PDF_MIN_PAGE_FILL ? withHeaders : safeBreak;
            }

            const sliceHeight = Math.max(1, Math.round(end) - start);

            sliceCanvas.height = sliceHeight;
            sliceContext.fillStyle = backgroundColor ?? "#FFFFFF";
            sliceContext.fillRect(0, 0, sliceCanvas.width, sliceHeight);
            sliceContext.drawImage(canvas, 0, start, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight);

            if (pages > 0) pdf.addPage();

            addPdfHeader(pdf, pageWidth, margin, title, subtitleLines);

            pdf.addImage(sliceCanvas.toDataURL("image/png"), "PNG", margin, margin + resolvedHeaderHeight, imgWidth, sliceHeight / pxPerMm, undefined, "FAST");

            start += sliceHeight;
            pages += 1;
        }

        pdf.save(fileName ?? `${elementId}.pdf`);

        onSuccess?.();
    } catch (err) {
        onError?.(err);
    } finally {
        afterCapture?.();
        setExporting?.(false);
    }
};

// EXPORTAÇÃO DE CSV

// Separador ";" e BOM UTF-8: é o que o Excel em pt-BR espera para abrir acentos e colunas corretamente.
const CSV_SEPARATOR = ";";
const CSV_BOM = "﻿";

const escapeCsvValue = (value) => {
    const text = value === null || value === undefined ? "" : String(value);

    return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/**
 * Gera um CSV com uma ou mais tabelas, cada uma com título, cabeçalho e linhas, separadas por uma linha em branco.
 *
 * @param {string}   fileName nome do arquivo salvo.
 * @param {Array<{ title?: string, headers?: string[], rows: Array<Array<*>> }>} sections tabelas do arquivo; as vazias são ignoradas.
 */
export const exportToCSV = ({ fileName, sections, onSuccess, onError }) => {
    try {
        const lines = [];

        sections
            .filter((section) => section?.rows?.length > 0)
            .forEach((section, index) => {
                if (index > 0) lines.push("");
                if (section.title) lines.push(escapeCsvValue(section.title));
                if (section.headers) lines.push(section.headers.map(escapeCsvValue).join(CSV_SEPARATOR));

                section.rows.forEach((row) => lines.push(row.map(escapeCsvValue).join(CSV_SEPARATOR)));
            });

        const url = URL.createObjectURL(new Blob([CSV_BOM + lines.join("\r\n")], { type: "text/csv;charset=utf-8;" }));
        const link = document.createElement("a");

        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);

        onSuccess?.();
    } catch (err) {
        onError?.(err);
    }
};
